// extracted by mini-css-extract-plugin
module.exports = {"card":"card-3wiQj","header":"header-2cP4F","large":"large-1slon","content":"content-1_7rR"};